import Consultante from './Consultante';

export default Consultante;